import React, { useState } from 'react';
import styled from '@emotion/styled';
import { NavLink } from 'react-router-dom';
import './index.css';
import SelectEl from 'common/components/Select';

const StyledNavLink = styled(NavLink)`
    font-family: "Mulish";
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 20px;
    color: ${(props) => props.theme.colors.primaryTextColor};
    transition: all 0.1s ease-in-out;
    &.active {
        color: ${(props) => props.theme.colors.primaryColor};
        font-weight: 800;
    } &:hover {
        color: ${(props) => props.theme.colors.primaryColor};
    }
`;
const selectData = [
  {
    value: 1,
    label: 'Робочий простір',
  }, {
    value: 2,
    label: 'Мій профіль',
  },
];

export default function SettingsMenu() {
  const [selected, setSelected] = useState(1);
  const handleSelect = (e) => {
    console.log(e.target.value);
    setSelected(e.target.value);
  };
  return (
    <div className='settings-navigation-wrapper'>
        <h3 className='settings-title'>НАЛАШТУВАННЯ</h3>
        <div className='settings-select-wrapper'>
            <SelectEl value={selected} onChange={handleSelect} data={selectData}></SelectEl>
        </div>
        <StyledNavLink to='/settings' end>Акаунт</StyledNavLink>
        <StyledNavLink to='/settings/confidentiality'>Конфіденційність</StyledNavLink>
        <StyledNavLink to='/settings/security'>Безпека</StyledNavLink>
        <StyledNavLink to='/settings/confidentiality'>Cповіщення</StyledNavLink>
        <StyledNavLink to='/settings/subscriptions'>Підписки</StyledNavLink>
        <StyledNavLink to='/settings/users_and_roles'>Користувачі і ролі</StyledNavLink>
        <StyledNavLink to='/settings/support'>Допомога</StyledNavLink>
        <StyledNavLink to='/settings/integrations'>Інтеграції</StyledNavLink>
    </div>
  );
}